// export default function (userData) {
//     // Extract userRole and parentId from userData
//     const userRole = userData?.role;
//     const parentId = userData?.site?.parentId ? userData?.site?.parentId : 0;
//     // Get the current brand from the environment variable
//     const brand = process.env.VUE_APP_BRAND;

//     if (brand === 'LOCUMATE' || brand === 'HEYLUCY') {
//         const siteId = userData?.site?.id ? userData?.site?.id : 0;

//         // Condition for Australia Pharmacy types
//         // siteId === 1 means Community Pharmacy
//         if (siteId === 1) {
//             return true;
//         } else {
//             return false;
//         }
//     }

//     // Logic for HEALTHSHIFTS brand
//     if (brand === 'HEALTHSHIFTS') {
//         // Check if both conditions are met
//         if (userRole === 'pharmacy' && parentId === 1) {
//             return true; // return true if the condition is met
//         } else {
//             return false; // return false if the condition is not met
//         }
//     }

//     // For other brands, always return true
//     return true;
// }


export default function (userData) {
    const userRole = userData?.role;
    const parentId = userData?.site?.parentId || 0;
    const siteId = userData?.site?.id || 0;
    const brand = process.env.VUE_APP_BRAND;

    // Logic for LOCUMATE and HEYLUCY brands
    if (brand === 'LOCUMATE' || brand === 'HEYLUCY') {
        const isCommunityPharmacy = siteId === 1;
        const isHospitalPharmacy = parentId === 2;

        return {
            isValid: isCommunityPharmacy || isHospitalPharmacy, // True if either condition is met
            isCommunityPharmacy,
            isHospitalPharmacy
        };
    }

    // Logic for HEALTHSHIFTS brand (Always return true if conditions are not met)
    if (brand === 'HEALTHSHIFTS') {
        // Check if both conditions are met
        if (userRole === 'pharmacy' && parentId === 1) {
            return true; // return true if the condition is met
        } else {
            return false; // return false if the condition is not met
        }
    }

    // Default case for other brands (Return an object for consistency)
    return { isValid: true, isCommunityPharmacy: false, isHospitalPharmacy: false };
}